import { render, staticRenderFns } from "./my_informal_wage_record_modal.vue?vue&type=template&id=f927a89a&scoped=true"
import script from "./my_informal_wage_record_modal.vue?vue&type=script&lang=js"
export * from "./my_informal_wage_record_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f927a89a",
  null
  
)

export default component.exports